/**
 * Generates a SpEL filter expression for a language code.
 *
 * Round-trip format: literal single space on either side of `==`, single
 * quotes around the field name and value (no double quotes), no extra
 * whitespace, no compound conditions.
 *
 * Example: languageToExpression("en") => "['_locale'] == 'en'"
 */
export function languageToExpression(languageCode: string): string {
  return `['_locale'] == '${languageCode}'`;
}

/**
 * Extracts the language code from a SpEL filter expression.
 *
 * Strict: matches only the exact emit shape produced by languageToExpression.
 * Returns `undefined` for variant forms (double quotes, extra whitespace,
 * compound expressions, bare field name, etc.); no UI path produces them.
 */
export function expressionToLanguage(expression: string): string | undefined {
  const match = expression.match(/^\['_locale'\] == '([^']+)'$/);
  return match ? match[1] : undefined;
}
